
import PreEntryApi from '../../assets/js/preentry'
import Validate from '../../assets/js/pre_validate'
import { i18nHelper } from '@it-common/lbp_common'
import OnboardHeader from '../OnboardHeader'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

export default {
components: {
XButton,
Flexbox,
Loading,
FlexboxItem,
Alert,
Confirm,
OnboardHeader
},
data () {
return {
isZH: true,
offerUrl: {
1: 'onboard.white_offer', // 白领英文模板
8: 'onboard.white_offer', // 白领英文模板
2: 'onboard.blue_offer', // 蓝领模板
3: 'onboard.store_offer', // 店端模板
5: 'onboard.intern_offer', // 实习生模板
6: 'onboard.intern_blue_offer', // 实习生蓝领模板
7: 'onboard.intern_store_offer', // 实习生蓝领模板
9: 'onboard.social_intern_store_offer', // 实习生蓝领模板
10: 'onboard.white_offer_rsu', // 白领模板
11: 'onboard.blue_offer_elementary', // 蓝领S0-S3版本
12: 'onboard.school_offer', // 校招模板
13: 'onboard.school_offer_ssp', // 校招模板(含股权)
14: 'onboard.school_store_offer', // 店端校招模板（新）
15: 'onboard.school_offer_bj', // 校招模板 - 北京（确认落户）
16: 'onboard.school_offer_sh', // 校招模板 - 上海（确认落户）
17: 'onboard.school_offer_sale', // 校招模板 - 售后
18: 'onboard.school_offer_prod', // 校招模板 - 产品交付
19: 'onboard.school_offer_prod_sale', // 校招模板 - 产品专家（电销）
20: 'onboard.school_offer_bj_chj', // 校招模板 - 北京车和家汽车科技
21: 'onboard.school_offer_sh_lxqc', // 校招模板 - 上海理想汽车
22: 'onboard.blue_offer_elementary_joint', // 蓝领S0-S3版本 - 合资
23: 'onboard.white_offer_joint', // 白领无股权模板 - 合资
24: 'onboard.blue_offer_joint', // 蓝领S4-S9版本 - 合资
25: 'onboard.white_school_offer_stock', // 2023白领校招Offer Letter-含股权
26: 'onboard.white_school_offer', // 2023白领校招Offer Letter-不含股权
27: 'onboard.store_school_offer_sale', // 2023店端校招Offer Letter-电销&服务
28: 'onboard.store_school_offer_product', // 2023店端校招Offer Letter-产品交付&维修
29: 'onboard.white_school_offer_stock_rr', // 2022白领校招Offer Letter-含股权
30: 'onboard.white_school_offer_rr', // 2022白领校招Offer Letter-不含股权
31: 'onboard.store_school_offer_sale_rr', // 2022店端校招Offer Letter-电销&服务
32: 'onboard.store_school_offer_product_rr', // 2022店端校招Offer Letter-产品交付&维修
33: 'onboard.white_school_offer_xc', // 2023白领校招Offer Letter-四川理想新晨
34: 'onboard.white_school_offer_cdwl', // 2023白领校招Offer Letter-充电网络
35: 'onboard.white_school_offer_en', // 2023白领校招Offer Letter-不含股权（英文版）
36: 'onboard.white_school_offer_int_en', // 实习生offer模版（英文版）
37: 'onboard.school_sales_school', // 校企售后实习生offer

40: 'onboard.new_white_offer', // 白领模板
41: 'onboard.new_white_offer_en', // 白领英文模板
42: 'onboard.new_store_offer', // 店端offer
43: 'onboard.new_blue_offer', // 蓝领offer
44: 'onboard.new_intern_offer', // 实习offer
45: 'onboard.new_blue_research_offer', // 研发蓝领 offer
46: 'onboard.new_white_school_offer_stock', // 校招有股权 offer
47: 'onboard.new_white_school_offer', // 校招没股权 offer
48: 'onboard.new_white_school_offer_en', // 校招英文 不含股权 offer
49: 'onboard.new_store_school_offer', // 店端校招offer
50: 'onboard.new_white_school_charging_network_offer', // 白领校招充电网络
51: 'onboard.new_white_school_int_en_offer', // 校招实习生英文offer
52: 'onboard.new_blue_intern_offer', // 蓝领校企实习生
100: 'onboard.new_common_offer' // 公共模板
},
submit_status: '',
status: '',
relationItems: [],
relation2Items: [],
educationItems: [],
degreeItems: [],
studyStyleItems: [],
familyItems: [],
sexItems: [],
hasFriendItems: [
{ key: 1, value: this.$tsg('是') },
{ key: 2, value: this.$tsg('否') }
],
icTypeItems: [],
politicalOutlookItems: [],
registeredTypeItems: [],
residenceTypeItems: [],
marriageItems: [],

state: {
sex_state: 1,
name_state: 1,

ic_no_state: 1,
nation_state: 1,
mobile_state: 1,
ic_type_state: 1,
marriage_state: 1,
passport_state: 1,
job_card_state: 1,
birthday_state: 1,
is_drive_state: 1,
bank_card_state: 1,
bank_type_state: 1,
country_id_state: 1,
has_friend_state: 1,
friend_name_state: 1,
name_pinyin_state: 1,
quit_certify_state: 1,
home_address_state: 1,
is_insurance_state: 3,
country_name_state: 1,
ic_expired_date_state: 1,
bank_card_info_state: 1,
bank_city_state: 1,
registered_type_state: 1,
residence_type_state: 1,
surname_pinyin_state: 1,
residence_self_state: 3,
residence_first_state: 3,
first_work_date_state: 1,


is_self_computer_state: 2,
political_status_state: 1,
current_address_state: 1,
emergency_contact_state: 1,
identity_card_back_state: 1,
is_out_insurance_state: 3,
physical_examination_state: 3,
register_address_state: 3,
identity_card_positive_state: 1,
emergency_contact_mobile_state: 1,
emergency_contact_relation_state: 1,
native_place_name_state: 1,
city_name_state: 3,
work_schedules_state: 1
},
state_msg: {
sex_state: this.$tsg('性别未选择！') + '<br/>',
name_state: this.$tsg('名称未填写！') + '<br/>',

ic_no_state: this.$tsg('证件号码未填写！') + '<br/>',
nation_state: this.$tsg('民族未选择！') + '<br/>',
mobile_state: this.$tsg('电话号码未填写或格式错误！') + '<br/>',

ic_type_state: this.$tsg('证件类型未选择！') + '<br/>',
job_card_state: this.$tsg('工卡照片未上传！') + '<br/>',
marriage_state: this.$tsg('婚育状况未填写！') + '<br/>',
passport_state: this.$tsg('护照未上传！') + '<br/>',
birthday_state: this.$tsg('生日未选择！') + '<br/>',
is_drive_state: this.$tsg('是否开车上班未选择！') + '<br/>',
bank_card_state: this.$tsg('银行卡号未填写！') + '<br/>',
bank_type_state: this.$tsg('开户银行未填写！') + '<br/>',
has_friend_state: this.$tsg('是否有亲属/原同事在我公司工作未选择！') + '<br/>',
country_id_state: this.$tsg('国籍未选择！') + '<br/>',
friend_name_state: this.$tsg('在职亲属/原同事姓名！') + '<br/>',
name_pinyin_state: this.$tsg('姓(全拼)输入不正确！') + '<br/>',
home_address_state: this.$tsg('家庭住址未填写！') + '<br/>',
is_insurance_state: this.$tsg('是否在京缴纳过社保未选择！') + '<br/>',
country_name_state: this.$tsg('国籍未选择！') + '<br/>',
native_place_name_state: this.$tsg('籍贯省份未选择！') + '<br/>',

ic_expired_date_state: this.$tsg('证件有效期未填写！') + '<br/>',
bank_card_info_state: this.$tsg('开户行信息填写有误！') + '<br/>',
bank_city_state: this.$tsg('开户行所在城市未填写！') + '<br/>',
registered_type_state: this.$tsg('户口类型未选择！') + '<br/>',
residence_type_state: this.$tsg('户口性质未选择！') + '<br/>',
surname_pinyin_state: this.$tsg('名(全拼)输入不正确！') + '<br/>',


first_work_date_state: this.$tsg('首次参加工作时间未填写！') + '<br/>',
work_experience_state: this.$tsg('工作经历未填写！') + '<br/>',
train_experience_state: this.$tsg('培训经历未填写！') + '<br/>',
is_self_computer_state: this.$tsg('是否自带电脑未选择！') + '<br/>',
political_status_state: this.$tsg('政治面貌未选择！') + '<br/>',
current_address_state: this.$tsg('现居住地址未填写！') + '<br/>',
emergency_contact_state: this.$tsg('紧急联系人未填写！') + '<br/>',
identity_card_back_state: this.$tsg('身份证国徽面未上传！') + '<br/>',
is_out_insurance_state: this.$tsg('是否将社保转出过外地未选择！') + '<br/>',
quit_certify_state: this.$tsg('离职证明未上传！') + '<br/>',
physical_examination_state: this.$tsg('体检报告未上传！') + '<br/>',
register_address_state: this.$tsg('户籍所在地未填写！') + '<br/>',
identity_card_positive_state: this.$tsg('身份证正面未上传！') + 'x<br/>',
work_schedules_state: this.$tsg('上下班时间未选择！') + '<br/>',
emergency_contact_mobile_state: this.$tsg('紧急联系电话未填写或格式不正确！') + '<br/>',
emergency_contact_relation_state: this.$tsg('与紧急联系人关系未填写！') + '<br/>'
},
sex: '',
name: '',
ic_no: '',
email: '',
nation: '',
mobile: '',
degree: '',
diploma: '',
ic_type: '',
birthday: '',
marriage: '',
job_card: '',
car_info: '',
is_drive: '',
bank_card: '',
bank_type: '',
has_friend: '',
country_id: '',
name_pinyin: '',
friend_name: '',
home_address: '',
passport_url: '',
country_name: '',
is_insurance: '',
quit_certify: '',
family_member: '',
work_city_name: '',
ic_expired_date: '',
residence_self: '',
surname_pinyin: '',
residence_type: '',
bank_card_info: '',
bank_city: '',
residence_first: '',
work_experience: '',
first_work_date: '',
study_experience: '',
is_self_computer: '',
operating_system: '',
emergency_contact: '',
political_status: '',
train_experience: '',
current_address: '',
is_out_insurance: '',
native_place_name: '',
city_name: '',
physical_examination: '',
identity_card_back_url: '',
register_address_path: '',
register_address: '',
emergency_contact_mobile: '',
emergency_contact_relation: '',
emergency_contact_address: '',
student_card: '',
identity_card_positive_url: '',
showLoading: true,

no_working: 1,
no_training: 2,

showError: false,
errMsg: '',
code: '',
work_schedules: '',
subMitConfirm: false,

info_edu_status: '',
info_work_status: '',
info_train_status: '',
info_family_status: '',
info_upload_status: '',
info_certify_status: '',
info_material_status: '',
info_supplement_status: '',
medical_status: 1,
certify_status: 1,
certify_memo: '',
medical_memo: '',
leftOptions: this.$tsg('返回'),
closeFlag: false,
registered_type: 1,
submitDisabled: true,
isSubmit: false,

isBlueCollar: '',
isTrainee: '',
hiringType: '',
workType: '',
jobType: '',

is_show_diploma: true,

is_show_degree: true,
level: ''
}
},
created () {
this.postPsOption()

this.id = this.$route.query.id

var localStorage = window.localStorage
this.isZH = localStorage.getItem('offer_zh') === 'zh'

this.code = localStorage.getItem('pre_code')
i18nHelper.loadLanguagePack(4159)
i18nHelper.setFixedLocale(localStorage.getItem('offer_zh'))
this.$forceUpdate()

if (!this.code || !this.id) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}

PreEntryApi.checkLogin(
{ id: this.id, code: this.code },
data => {
if (data) {
this.isSubmit = data.isSubmit
if (this.isSubmit) {
this.leftOptions = this.$tsg('关闭')
}
}
},
err => {
this.showLoading = false
if (err === -2) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
},
() => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
},
() => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
)

PreEntryApi.getStatusValue({ id: this.id, code: this.code }, data => {
if (data) {
this.info_edu_status = data.info_edu_status
this.status = data.status
this.info_work_status = data.info_work_status
this.info_train_status = data.info_train_status
this.info_family_status = data.info_family_status
this.info_upload_status = data.info_upload_status
this.info_certify_status = data.info_certify_status
this.info_material_status = data.info_material_status
this.info_supplement_status = data.info_supplement_status
this.no_working = data.no_working
if (
this.info_edu_status === 3 &&
this.info_work_status === 3 &&
this.info_train_status === 3 &&
this.info_family_status === 3 &&
this.info_upload_status === 3 &&
this.info_certify_status === 3 &&
this.info_material_status === 3 &&
this.info_supplement_status === 3
) {
this.submitDisabled = false
}
}
})

this.showLoading = true
try {
PreEntryApi.getStaffDetail({ id: this.id, code: this.code }, data => {
if (data) {
this.hiringType = data.hiring_type
PreEntryApi.getMaterial(
{ id: this.id, code: this.code },
(data, meta) => {
if (data) {
if (data.study_experience.length > 0) {
var studyExperience = data.study_experience.sort(function (a, b) {
return a.education - b.education
})
if (studyExperience[0].education >= 4) {
this.is_show_degree = false
}
if (studyExperience[0].education >= 10) {
this.is_show_diploma = false
}
if (studyExperience[0].education <= 3) {
this.is_show_degree = true
}
}
}
this.showLoading = false
},
err => {
this.showLoading = false
}
)

if (data.hiring_type === 2) {
PreEntryApi.getExperience(
{ id: this.id, getField: 'work_experience', code: this.code },
(data, meta) => {
if (data) {
data.forEach(item => {
if (item.work_type === 2) {
this.workType = 2
}
})
}
this.showLoading = false
},
err => {
this.showLoading = false
}
)
}
}
})
PreEntryApi.getUserInfo(
{ id: this.id, code: this.code },
data => {
if (data) {
var generalField = [
'sex', // 性别
'name', // 名称
'ic_no', // 证件号码
'work_schedules', // 上下班时间

'nation', // 民族
'mobile', // 手机号码
'ic_type', // 证件类型
'birthday', // 生日
'is_drive', // 请问您是否开车上下班
'marriage', // 婚育状况
'bank_card', // 银行卡号
'has_friend', // 是否有亲属/原同事在我司
'country_id', // 国籍
'name_pinyin', // 名(全拼)
'friend_name',
'is_insurance', // 是否在京缴纳过社保
'home_address', // 家庭住址
'country_name',
'ic_expired_date', // 证件有效期
'work_city_name',
'surname_pinyin', // 姓(全拼)
'registered_type', // 户口类型
'residence_type', // 户口性质
'bank_card_info', // 开户行信息
'bank_type', // 开户行
'bank_city', // 开户行所在城市
'first_work_date', // 首次工作时间
'is_self_computer', // 否自带笔记本电脑办公
'operating_system', // 操作系统
'current_address', // 现居住地址
'political_status', // 政治面貌
'emergency_contact', // 紧急联系人姓名
'is_out_insurance', // 是否将社保转出过外地
'register_address', // 户籍所在地
'native_place_name', // 籍贯省份
'city_name', // 籍贯城市
'emergency_contact_relation', // 与紧急联系人关系
'emergency_contact_mobile', // 紧急联系人电话
'emergency_contact_address' 
]

this.job_card = data.job_card
data.physical_examination ? this.formatImageItems(data.physical_examination, 'physical_examination') : ''
data.quit_certify ? this.formatImageItems(data.quit_certify, 'quit_certify') : ''
data.residence_first ? this.formatImageItems(data.residence_first, 'residence_first') : ''
data.residence_self ? this.formatImageItems(data.residence_self, 'residence_self') : ''
data.diploma ? this.formatImageItems(data.diploma, 'diploma') : ''
data.degree ? this.formatImageItems(data.degree, 'degree') : ''
data.student_card ? this.formatImageItems(data.student_card, 'student_card') : ''
this.submit_status = data.submit_status
for (var i in data) {
if (generalField.indexOf(i) !== -1) {
this[i] = data[i]
if (i === 'register_address') {
var registerProvinceName = data['register_province_name'] ? data['register_province_name'] : ''
var registerCityName = data['register_city_name'] ? data['register_city_name'] : ''
var registerCountyName = data['register_county_name'] ? data['register_county_name'] : ''
var address = data['register_address'] ? data['register_address'] : ''
this[i] = registerProvinceName + registerCityName + registerCountyName + address
}
if (i === 'home_address') {
var homeProvinceName = data['home_province_name'] ? data['home_province_name'] : ''
var homeCityName = data['home_city_name'] ? data['home_city_name'] : ''
var homeCountyName = data['home_county_name'] ? data['home_county_name'] : ''
var homeaddress = data['home_address'] ? data['home_address'] : ''
this[i] = homeProvinceName + homeCityName + homeCountyName + homeaddress
}
if (i === 'current_address') {
var currentProvinceName = data['current_province_name'] ? data['current_province_name'] : ''
var currentCityName = data['current_city_name'] ? data['current_city_name'] : ''
var currentCountyName = data['current_county_name'] ? data['current_county_name'] : ''
var caddress = data['current_address'] ? data['current_address'] : ''
this[i] = currentProvinceName + currentCityName + currentCountyName + caddress
}
if (i === 'emergency_contact_address') {
var eProvinceName = data['emergency_contact_province_name'] ? data['emergency_contact_province_name'] : ''
var eCityName = data['emergency_contact_city_name'] ? data['emergency_contact_city_name'] : ''
var eCountyName = data['emergency_contact_county_name'] ? data['emergency_contact_county_name'] : ''
var eaddress = data['emergency_contact_address'] ? data['emergency_contact_address'] : ''
this[i] = eProvinceName + eCityName + eCountyName + eaddress
}

if (this[i]) {
this['state'][i + '_state'] = 3
}
}
}
if (data.quit_certify.length > 0) {
this.state.quit_certify_state = 3
}

if (data.ic_expired_date === '0000-00-00' || data.ic_expired_date === '1900-01-01') {
this.state.ic_expired_date_state = 2
this.ic_expired_date = ''
}

if (data.first_work_date === '0000-00-00' || data.first_work_date === '1900-01-01') {
this.state.first_work_date_state = 2
}

var reg = /^[A-Za-z]+$/
if (!reg.test(data.surname_pinyin)) {
this.state.surname_pinyin_state = 2
}

if (!reg.test(data.name_pinyin)) {
this.state.name_pinyin_state = 2
}





if (data.name.length < 2) {
this.state.name_state = 2
}

if (data.job_card.length > 0) {
this.state.job_card_state = 3
}

if (data.has_friend === 1) {
if (data.friend_name) {
this.state.friend_name_state = 3
} else {
this.state.friend_name_state = 1
}
} else {
this.state.friend_name_state = 3
}

if (data.residence_self.length > 0 || data.ic_type !== 1) {
this.state.residence_self_state = 3
}

if (data.residence_first.length > 0 || data.ic_type !== 1) {
this.state.residence_first_state = 3
}

if (data.physical_examination.length > 0) {
this.state.physical_examination_state = 3
}

this.car_info = data.car_info
if (this.car_info.length > 0 && this.is_drive === 1) {
for (var ii = 0; ii < data.car_info.length; ii++) {
this.car_info[ii]['brand_state'] = data['car_info'][ii]['brand'] ? 3 : 1
this.car_info[ii]['type_state'] = data['car_info'][ii]['type'] ? 3 : 1
this.car_info[ii]['number_state'] = data['car_info'][ii]['number'] ? 3 : 1
/*
if(!data.car_info[ii][ 'number' ]) {
this.car_info[ii][ 'number_state' ] = 1;
} else if(!Validate.isVehicleNumber(this.car_info[ii][ 'number' ])){
this.car_info[ii][ 'number_state' ] = 2;
} else {
this.car_info[ii][ 'number_state' ] = 3;
}
*/
}
}

this.train_experience = data.train_experience

this.family_member = data.family_member
if (data.family_member.length) {
for (var z = 0; z < data.family_member.length; z++) {
this.family_member[z]['birthday_state'] = 3
this.family_member[z]['name_state'] = data.family_member[z]['name'] ? 3 : 1
this.family_member[z]['profession_state'] = data.family_member[z]['profession'] ? 3 : 1
this.family_member[z]['relation_state'] = data.family_member[z]['relation'] ? 3 : 1
this.family_member[z]['work_unit_state'] = data.family_member[z]['work_unit'] ? 3 : 1
if (!data.family_member[z]['contact_number']) {
this.family_member[z]['contact_number_state'] = 1
} else if (localStorage.getItem('offer_zh') === 'zh' && !Validate.isMobile(data.family_member[z]['contact_number'])) {
this.family_member[z]['contact_number_state'] = 2
} else {
this.family_member[z]['contact_number_state'] = 3
}
}
}

this.work_experience = data.work_experience

this.study_experience = data.study_experience
if (data.study_experience.length) {
for (var zz = 0; zz < data.study_experience.length; zz++) {
this.study_experience[zz]['education_state'] = data.study_experience[zz]['education'] ? 3 : 1
this.study_experience[zz]['major_state'] = data.study_experience[zz]['major'] ? 3 : 1
this.study_experience[zz]['school_state'] = data.study_experience[zz]['school'] ? 3 : 1
this.study_experience[zz]['start_date_state'] = data.study_experience[zz]['start_date'] ? 3 : 1
this.study_experience[zz]['end_date_state'] = data.study_experience[zz]['end_date'] ? 3 : 1
this.study_experience[zz]['study_style_state'] = data.study_experience[zz]['study_style'] ? 3 : 1
this.study_experience[zz]['school_country_state'] = data.study_experience[zz]['school_country'] ? 3 : 1
}
}

if (data.ic_type !== 1) {
this.state.identity_card_positive_state = 3
this.state.identity_card_back_state = 3

this.state.native_place_name_state = 3
this.state.city_name_state = 3
this.state.nation_state = 3

this.state.emergency_contact_mobile_state = 3
this.state.emergency_contact_state = 3

this.state.registered_type_state = 3 
this.state.residence_type_state = 3 
this.state.political_status_state = 3

if (data.passport && data.passport.length > 0) {
this.passport_url = data.passport[0].src
this.state.passport_state = 3
}
if (this.emergency_contact_mobile.length > 0 && localStorage.getItem('offer_zh') === 'zh' && !Validate.isMobile(this.emergency_contact_mobile)) {
this.state.emergency_contact_mobile_state = 2
}
} else {
this.state.passport_state = 3

if (data.identity_card_positive && data.identity_card_positive.length > 0) {
this.identity_card_positive_url = data.identity_card_positive[0].src
this.state.identity_card_positive_state = 3
}

if (data.identity_card_back && data.identity_card_back.length > 0) {
this.identity_card_back_url = data.identity_card_back[0].src
this.state.identity_card_back_state = 3
}


if (localStorage.getItem('offer_zh') === 'zh' && !Validate.isMobile(this.emergency_contact_mobile)) {
this.state.emergency_contact_mobile_state = 2
}
}


if (localStorage.getItem('offer_zh') === 'zh' && !Validate.isMobile(this.mobile)) {
this.state.mobile_state = 2
}

/*

if(!Validate.isEmail(this.email)) {
this.state.email_state = 2;
}
*/

if (data.work_city_name !== '北京') {
this.state.is_insurance_state = 3
}

this.jobType = data.job_type
this.level = data.level
this.isTrainee = data.is_intern
this.isBlueCollar = data.is_blue_collar
this.department2ID = data.department2_id








this.showLoading = false
}


PreEntryApi.getStatusValue({ id: this.id, code: this.code }, data => {
if (data) {
this.no_working = data.no_working
this.no_training = data.no_training
this.back_status = data.back_status
this.positive_status = data.positive_status
this.passport_status = data.passport_status
this.info_work_status = data.info_work_status
this.info_train_status = data.info_train_status

this.certify_status = data.certify_status
this.medical_status = data.medical_status
this.certify_memo = data.certify_memo
this.medical_memo = data.medical_memo

if (this.no_training === 2) {
this.state.train_experience_state = 3
}

if (this.info_train_status === 3) {
this.state.train_experience_state = 3
}

if (this.train_experience.length && this.no_training === 1) {
for (var ss = 0; ss < this.train_experience.length; ss++) {
this.train_experience[ss]['education_state'] = this.train_experience[ss]['education'] ? 3 : 1
this.train_experience[ss]['entry_date_state'] = this.train_experience[ss]['entry_date'] ? 3 : 1
this.train_experience[ss]['quit_date_state'] = this.train_experience[ss]['quit_date'] ? 3 : 1
this.train_experience[ss]['train_content_state'] = this.train_experience[ss]['train_content'] ? 3 : 1
this.train_experience[ss]['train_institution_state'] = this.train_experience[ss]['train_institution']
? 3
: 1
}
}

if (this.work_experience.length && this.no_working === 1 && this.isTrainee !== 1) {
for (var kk = 0; kk < this.work_experience.length; kk++) {
this.work_experience[kk]['entry_date_state'] = this.work_experience[kk]['entry_date'] ? 3 : 1
this.work_experience[kk]['quit_date_state'] = this.work_experience[kk]['quit_date'] ? 3 : 1

this.work_experience[kk]['depart_state'] = this.work_experience[kk]['depart'] ? 3 : 1
this.work_experience[kk]['post_state'] = this.work_experience[kk]['post'] ? 3 : 1
this.work_experience[kk]['reterence_state'] = this.work_experience[kk]['reterence'] ? 3 : 1
this.work_experience[kk]['quit_cause_state'] = this.work_experience[kk]['quit_cause'] ? 3 : 1
this.work_experience[kk]['company_state'] = this.work_experience[kk]['company'] ? 3 : 1
this.work_experience[kk]['work_type_state'] = this.hiringType === 1 || this.work_experience[kk]['work_type'] ? 3 : 1

if (!this.work_experience[kk]['contact_number']) {
this.work_experience[kk]['contact_number_state'] = 1
} else if (localStorage.getItem('offer_zh') === 'zh' && !Validate.isMobile(this.work_experience[kk]['contact_number'])) {
this.work_experience[kk]['contact_number_state'] = 2
} else {
this.work_experience[kk]['contact_number_state'] = 3
}
}
}

if (this.isTrainee === 1) {
this.state.is_out_insurance_state = 3
this.state.is_insurance_state = 3
this.state.first_work_date_state = 3
this.state.quit_certify_state = 3
}
}
})
},
(err) => {
console.log(err)
if (err === -2) {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
}
this.showLoading = false
},
() => {
this.showLoading = false
}
)
} catch (e) {
this.$message.error('系统内部错误。')
this.showLoading = false
return false
}
},
methods: {
postPsOption () {
PreEntryApi.postPsOption(
{},
(data, meta) => {

const icTypeObj = data['1'] || {}
this.icTypeItems = Object.keys(icTypeObj).map(key => ({
key: Number(key),
value: icTypeObj[key]
}))

const sexObj = data['2'] || {}
this.sexItems = Object.keys(sexObj).map(key => ({
key: Number(key),
value: sexObj[key]
}))

const residenceTypeObj = data['3'] || {}
this.residenceTypeItems = Object.keys(residenceTypeObj).map(key => ({
key: Number(key),
value: residenceTypeObj[key]
}))
const registeredTypeObj2 = data['4'] || {}
this.registeredTypeItems = Object.keys(registeredTypeObj2)

.map(key => ({
key: Number(key),
value: registeredTypeObj2[key]
}))

const marriageObj = data['5'] || {}
this.marriageItems = Object.keys(marriageObj).map(key => ({
key: Number(key),
value: marriageObj[key]
}))

const politicalObj = data['6'] || {}
this.politicalOutlookItems = Object.keys(politicalObj).map(key => ({
key: Number(key),
value: politicalObj[key]
}))

const typeObj = data['7'] || {}
this.relation2Items = Object.keys(typeObj).map(key => ({
key: Number(key),
value: typeObj[key]
}))

const degreeTypeObj = data['8'] || {}
this.educationItems = Object.keys(degreeTypeObj).map(key => ({
key: Number(key),
value: degreeTypeObj[key]
}))

const studyTypeObj = data['9'] || {}
this.studyStyleItems = Object.keys(studyTypeObj).map(key => ({
key: Number(key),
value: studyTypeObj[key]
}))


const emergencyObj = data['12'] || {}
this.relationItems = Object.keys(emergencyObj).map(key => ({
key: key,
value: emergencyObj[key]
}))

const nationObj = data['13'] || {}
this.nationItems = Object.keys(nationObj).map(key => ({
title: nationObj[key],
other: Number(key)
}))
this.nationChangeItems = this.nationItems

const dgTypeObj = data['14'] || {}
this.degreeItems = Object.keys(dgTypeObj).map(key => ({
key: Number(key),
value: dgTypeObj[key]
}))

this.showLoading = false
},
err => {
this.$message.error(this.$tsg('选项数据获取失败。'))
this.showLoading = false
}
)
},
onClickBack () {
if (this.isSubmit) {
this.closeFlag = true
} else {
this.$router.push({
name: 'onboard.code',
query: { id: this.id }
})
}
},
sendClose () {
var userAgent = navigator.userAgent
if (userAgent.indexOf('Firefox') !== -1 || userAgent.indexOf('Chrome') !== -1) {
window.location.href = 'about:blank'
window.close()
} else {
window.opener = null
window.open('', '_self', '')
window.close()
}
},
sub () {
this.subMitConfirm = true
},
sendSub () {
if (this.no_working === 2) {
this.state.quit_certify_state = 3
}


if (this.jobType === 2 && [129, 103, 1703].indexOf(this.department2ID) !== -1) {
this.state.physical_examination_state = 3
}

if ((this.isTrainee === 1 && this.jobType === 2) || (this.no_working === 2 && this.jobType === 2)) {
this.state.physical_examination_state = 3
this.state.quit_certify_state = 3
}

this.errMsg = ''
var errStr = '<div style="font-size:14px;color:red;text-align:left;">'
for (var i in this.state) {
if (this.state[i] !== 3) {
this.errMsg += this.state_msg[i]
}
}


if (this.info_edu_status !== 3) {
this.errMsg += this.$tsg('教育经历未完善！') + '<br/>'
}

if (this.info_work_status !== 3) {
this.errMsg += this.$tsg('工作经历未完善！') + '<br/>'
}

if (this.info_train_status !== 3) {
this.errMsg += this.$tsg('培训经历未完善！') + '<br/>'
}

if (this.info_family_status !== 3) {
this.errMsg += this.$tsg('家庭情况未完善！') + '<br/>'
}

if (this.info_upload_status !== 3) {
this.errMsg += this.$tsg('证件资料未完善！') + '<br/>'
}

if (this.info_certify_status !== 3 && ((this.isTrainee !== 1 && this.no_working !== 2) || this.jobType !== 2)) {
this.errMsg += this.$tsg('入职必备未完善！') + '<br/>'
}

if (this.info_supplement_status !== 3) {
this.errMsg += this.$tsg('其他信息未完善！') + '<br/>'
}

if (this.info_material_status !== 3) {
this.errMsg += this.$tsg('基本信息未完善！') + '<br/>'
}


/*
var imageStatus = {
'reversed_side'   : '身份证正反面颠倒！<br/>',
'non_idcard'      : '上传的图片中不包含身份证！<br/>',
'blurred'         : '身份证模糊！<br/>',
'over_exposure'   : '身份证关键字段反光或过曝！<br/>',
'over_dark'       : '身份证欠曝（亮度过低）！<br/>',
'other_type_card' : '其他类型证照！<br/>',
'unknown'         : '未知状态！<br/>'
};
if(this.ic_type == 1) {
if(this.back_status != 'normal') {
errStr += imageStatus[this.back_status];
}
if(this.positive_status != 'normal') {
errStr += imageStatus[this.positive_status];
}
} else if(this.ic_type == 2) {

}
*/

if (this.errMsg) {
this.errMsg = errStr + this.errMsg
this.showError = true
return false
}

PreEntryApi.updateSubmitAt(
{ id: this.id, code: this.code },
data => {
if (data === '') {
this.$router.push({
name: 'onboard.success',
query: { id: this.id }
})
}
},
(err, message) => {
this.errMsg = message
this.showError = true
return false
}
)
},
list () {
this.$router.push({ name: 'onboard.list', query: { id: this.id } })
},



downloadOffer () {
PreEntryApi.getSubmitStatus({ id: this.id, code: this.code }, (statusData, meta) => {
if (statusData) {

if (statusData.is_special_offer === 1) {
this.$router.push({
name: 'onboard.special_offer',
query: { id: this.id, back: 1 }
})
return false
}
this.$router.push({
name: this.offerUrl[statusData.offer_type],
query: { id: this.id, back: 1 }
})
return false
}
})
},
formatImageItems (fields, fieldName) {
if (fields) {
this[fieldName] = []

var tempArray = []
fields.forEach(
function (item, index) {
var imgType = ['jpg', 'jpeg', 'png', 'gif']
if (imgType.indexOf(item.extension.toLowerCase()) === -1) {
if (item.extension.toLowerCase() === 'doc' || item.extension.toLowerCase() === 'docx') {
item.src = '/static/img/word.png'
} else {
item.src = '/static/img/pdf.png'
}
}
tempArray.push({
id: item.id,
src: item.src,
url: item.url
})
if ((index + 1) % 2 === 0 && index !== 0) {
this[fieldName].push(tempArray)
tempArray = []
}
}.bind(this)
)
if (tempArray.length) {
this[fieldName].push(tempArray)
tempArray = []
}
}
},
backUp () {
this.$router.go(-1)
},
getChild () {
if (this.country_id) {
this.provinceItems = []
PreEntryApi.getArea({ id: this.country_id }, data => {
this.provinceItems = data
})
}
},
getProvince (fn) {
if (this.province_id) {
this.cityItems = []
PreEntryApi.getArea({ id: this.province_id }, data => {
this.cityItems = data
fn && fn()
})
}
},

getIsZh (data) {
var localStorage = window.localStorage
if (data) {
localStorage.setItem('offer_zh', 'zh')

} else {
localStorage.setItem('offer_zh', 'en')

}
this.isZH = data
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/preview.vue